module.exports = __webpack_public_path__ + "static/media/report_1.74b2672e.jpg";